import apiClient from '@/core/api/client';
import { API_ENDPOINTS } from '@/core/api/endpoints';
import { ContactListResponse } from '../types';
import { AxiosError } from 'axios';

export const contactApi = {
    getContacts: async (params?: { page?: number; page_size?: number }): Promise<ContactListResponse> => {
        try {
            const response = await apiClient.get<ContactListResponse>(API_ENDPOINTS.CONTACT, { params });
            return response.data;
        } catch (error: unknown) {
            const axiosError = error as AxiosError<{ error?: string; message?: string }>;
            return {
                success: false,
                error: axiosError.response?.data?.error || axiosError.response?.data?.message || 'Failed to fetch contact inquiries'
            };
        }
    }
};
